/**
 * organcenter
 */

const App = () => import('@/module/index/layout/App.vue')
const organlist = () => import('@/module/index/pages/organcenter/organlist.vue')
const servicelist = () => import('@/module/index/pages/organcenter/servicelist.vue')
const addservice = () => import('@/module/index/pages/organcenter/addservice.vue')
const distribution = () => import('@/module/index/pages/organcenter/distribution.vue')
const comfirmlist = () => import('@/module/index/pages/organcenter/comfirmlist.vue')
const comfirmdetail = () => import('@/module/index/pages/organcenter/comfirmdetail.vue')
const mediatelist = () => import('@/module/index/pages/organcenter/mediatelist.vue')
const mediatedetail = () => import('@/module/index/pages/organcenter/mediatedetail.vue')
const dossierlist = () => import('@/module/index/pages/organcenter/dossierlist.vue')
const dossierdetail = () => import('@/module/index/pages/organcenter/dossierdetail.vue')
const peletterlist = () => import('@/module/index/pages/organcenter/peletterlist.vue')
const capabilityevaluate = () => import('@/module/index/pages/organcenter/capabilityevaluate.vue')
const capabilitydetail = () => import('@/module/index/pages/organcenter/capabilitydetail.vue')

export default {
  path: '/organcenter',
  component: App,
  meta: {
    title: '',
    requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
    isback: true
  },
  children: [{
    path: '/organcenter/organlist',
    component: organlist
  }, {
    path: '/organcenter/servicelist',
    component: servicelist
  }, {
    path: '/organcenter/addservice',
    component: addservice
  }, {
    path: '/organcenter/distribution',
    component: distribution
  }, {
    path: '/organcenter/distribution/:id',
    component: mediatedetail
  }, {
    path: '/organcenter/comfirmlist',
    component: comfirmlist
  }, {
    path: '/organcenter/comfirmlist/:id',
    component: comfirmdetail
  }, {
    path: '/organcenter/mediatelist',
    component: mediatelist
  }, {
    path: '/organcenter/mediatelist/:id',
    component: mediatedetail
  }, {
    path: '/organcenter/dossierlist',
    component: dossierlist
  }, {
    path: '/organcenter/dossierlist/:id',
    component: dossierdetail
  }, {
    path: '/organcenter/peletterlist',
    component: peletterlist
  }, {
    path: '/organcenter/capabilityevaluate',
    component: capabilityevaluate
  }, {
    path: '/organcenter/capabilityevaluate/:id',
    component: capabilitydetail
  }]
}



// WEBPACK FOOTER //
// ./src/publicResource/router/organcenter.js